<template>
  <a-modal
    title="订单支付"
    :width="600"
    :dialog-style="{ top: '20px' }"
    :maskClosable="false"
    :visible="visible"
    :footer="null"
    @cancel="visible=false"
  >
    <a-form layout="horizontal" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
      <!-- <a-form-item label="姓名">
        <a-input v-model="applyInfo.realname" placeholder="name" disabled/>
      </a-form-item>
      <a-form-item label="手机号">
        <a-input v-model="applyInfo.parentPhone" placeholder="phone" disabled/>
      </a-form-item> -->
      <a-form-item label="订单号">
        <a-input v-model="payInfo.orderNo" placeholder="订单号" disabled/>
      </a-form-item>
      <a-form-item label="金额">
        <a-input-number v-model="payInfo.orderPrice" placeholder="金额" disabled/>
      </a-form-item>
    </a-form>
    
    <div style="width: 400px;display:block;margin: auto;">
      <a-button v-if="!_isMobile()" @click="pay(1)" type="primary" icon="wechat">微信扫码支付</a-button>
      <a-button v-if="_isMobile() && !_isWeiXin()" @click="pay(2)" type="primary" icon="wechat">微信APP支付</a-button>
      <a-button v-if="_isWeiXin()" @click="pay(3)" type="primary" icon="wechat">微信支付</a-button>
      <a-divider type="vertical"></a-divider>
      <a-button v-if="!_isMobile()" @click="pay(4)" type="primary" icon="alipay">支付宝支付</a-button>
      <a-button v-if="_isMobile() && !_isWeiXin()" @click="pay(5)" type="primary" icon="alipay">支付宝APP支付</a-button>
    </div>
    <a-divider></a-divider>
    <p style="line-height:1.3em;color: red;">财务系统更新处理反馈需一定时间，如显示“未支付”请等待30分钟后刷新再次查询结果，谢谢。</p>
  </a-modal>
</template>
<script>
import Vue from 'vue'
import {randomUUID} from '@/utils/util'
import { getAction } from "@/api/manage";
import {mixinDevice} from '@/utils/mixin.js'
export default {
  name: "EventPay",
  mixins: [mixinDevice],
  data() {
    return {
      visible: false,
      pcAlipayUrl: "https://pay.cacpaper.com/alipay/pay.jsp",
      mobileAlipayUrl: "https://pay.cacpaper.com/alipay/wap-pay.jsp",
      pcWxpayUrl: "https://pay.cacpaper.com/wxpay/pay",
      pcUnionpayUrl: "https://pay.cacpaper.com/unionpay/pay",
      mobileWxpayUrl: "https://pay.cacpaper.com/wxpay/h5-pay",
      mobileWxpayInWxUrl: "https://pay.cacpaper.com/wxpay/mp-pay",
      mobileWxpayInMiniAppUrl: "https://pay.cacpaper.com/minipay/mini-pay",
      body: '报名费',
      applyInfo: {
      },
      payInfo: {
      },
      callbackUrl:  ""
    };
  },
  created() {},
  mounted(){
  },
  methods: {
    open(orderInfo, applyInfo){
      console.log(orderInfo);
      console.log(applyInfo);

      this.payInfo = {
        orderNo: orderInfo.orderNo,
        orderPrice: orderInfo.orderPrice / 100
      }
      //this.callbackUrl = window.location.protocol + "//" + window.location.host + "/cert/payResult.html?orderId=" + this.payInfo.orderNo
      this.callbackUrl = window.location.href + '#payok'
      this.applyInfo = applyInfo
      this.visible = true
    },
    checkOrder(orderId){
      getAction("/teaching/teachingOrder/checkOrderCAC?outTradeNo="+orderId).then(res=>{
        if(res.success){
          this.$message.success('支付成功');
          this.$emit("payOk")
        }else{
          this.$message.error(res.message);
        }
      })
    },
    pay(type) {
      let that = this
      let realname = ""
      if(this.applyInfo && this.applyInfo.realname){
        realname = this.applyInfo.realname
      }else{
        realname =  this.$store.getters.userInfo.realname
      }
      let body = "AICE测评-" + realname + this.payInfo.orderNo
      switch(type){
        case 1:
          this.pcWxpay(body, this.payInfo);
          break;
        case 2:
          this.mobileWxpay(body, this.payInfo);
          break;
        case 3:
          this.mobileWxpayInWx(body, this.payInfo);
          break;
        case 4:
          this.pcAlipay(body, this.payInfo);
           break;
        case 5:
          this.mobileAlipay(body, this.payInfo);
           break;
      }
      this.$confirm({
        title: '是否支付成功?',
        content: '请在打开的页面进行付款，付款后，确认付款结果',
        onOk() {
          that.checkOrder(that.payInfo.orderNo)
        },
        okText: "支付成功",
        onCancel() {
          that.checkOrder(that.payInfo.orderNo)
          alert("请联系老师处理")
        },
        cancelText: "支付失败"
      });
    },
    pcWxpay(body, payInfo) {
      let action = this.pcWxpayUrl;
      let params = {
        WX_out_trade_no: payInfo.orderNo,
        original_id: payInfo.orderNo,
        WX_product_id: "101",
        WX_total_fee: payInfo.orderPrice,
        WX_body: body,
        WX_return_url: this.callbackUrl,
      };
      let form = this.createForm(action, params, "_blank");
      form.submit();
    },
    mobileWxpay(body, payInfo) {
      let action = this.mobileWxpayUrl;
      let params = {
        WX_out_trade_no: payInfo.orderNo,
        original_id: payInfo.orderNo,
        WX_total_fee: payInfo.orderPrice,
        WX_body: body,
        WX_return_url: this.callbackUrl,
      };
      let form = this.createForm(action, params, "_blank");
      form.submit();
    },
    mobileWxpayInWx(body, payInfo) {
      let action = this.mobileWxpayInWxUrl;
      let params = {
        WX_out_trade_no: payInfo.orderNo,
        original_id: payInfo.orderNo,
        WX_total_fee: payInfo.orderPrice,
        WX_body: body,
        WX_return_url:this.callbackUrl,
      };
      
      let form = this.createForm(action, params, "_self");
      form.submit();
    },
    mobileAlipay(body, payInfo) {
      let action = this.mobileAlipayUrl;
      let params = {
        WIDout_trade_no: payInfo.orderNo,
        original_id: payInfo.orderNo,
        WIDsubject: body,
        WIDtotal_fee: payInfo.orderPrice,
        WIDbody: body,
        WIDreturn_url: this.callbackUrl
      };
      let form = this.createForm(action, params, "_self");
      form.submit();
    },
    pcAlipay(body, payInfo) {
      let action = this.pcAlipayUrl;
      let params = {
        WIDout_trade_no: payInfo.orderNo,
        WIDsubject: body,
        original_id: payInfo.orderNo,
        WIDtotal_fee: payInfo.orderPrice,
        WIDbody: body,
        WIDreturn_url:this.callbackUrl
      };
      let form = this.createForm(action, params, "_blank");
      form.submit();
    },
    pcUnionpay(body, payInfo) {
      let action = this.pcUnionpayUrl;
      let params = {
        orderId: payInfo.orderNo,
        txnAmt: payInfo.orderPrice,
        original_id: payInfo.orderNo,
        WIDsubject: "报名-"+body,
        WIDbody: body,
        channel: "pc",
        frontUrl: this.callbackUrl
      };
      let form = this.createForm(action, params, "_blank");
      form.submit();
    },
    mobileUnionpay(body, payInfo) {
      let action = this.pcUnionpayUrl;
      let params = {
        orderId: payInfo.orderNo,
        txnAmt: payInfo.orderPrice,
        original_id: payInfo.orderNo,
        WIDsubject: "报名-"+body,
        WIDbody: body,
        channel: "mobile",
        frontUrl:this.callbackUrl
      };
      let form = this.createForm(action, params, "_blank");
      form.submit();
    },
    //创建post表单
    createForm(action, params, target) {
      console.log("createForm");
      console.log(action);
      console.log(params);
      //alert(JSON.stringify(params))
      var temp = document.createElement("form"); //创建form标签
      temp.action = action; //这里写URL
      temp.method = "post"; //post方式提交
      temp.target = target
      temp.style.display = "none"; //设置为不可见
      for (var key in params) {
        var element;
        element = document.createElement("input");
        element.setAttribute("type", "hidden");
        element.name = key;
        element.value = params[key];
        temp.appendChild(element);
      }
      document.body.appendChild(temp); //将form标签添加到body标签内
      return temp;
    },
  },
};
</script>

<style>
</style>